import { useSelector } from 'react-redux';
import { RootState } from 'store';

import General from 'v3/templates/General';
import { Col } from 'antd';
import SidebarBox from 'v3/components/SidebarBox';
import Button from 'v3/components/Button';

import * as S from './styles';

const ZipcodeUnavailable = () => {
  const { leadData } = useSelector((state: RootState) => state.lead);

  return (
    <General>
      <Col xs={24} xl={12}>
        <S.Wrapper>
          <SidebarBox variant="secondary" as="section">
            <S.Title>
              Hi, <strong>{leadData.firstName}</strong>!
            </S.Title>
            <S.Description>
              At this moment, there are no clubs in your state.
            </S.Description>

            <S.Text>
              Savings Club is exclusively operating in <strong>Texas</strong>{' '}
              and <strong>Florida</strong> for now, but you’re on our waiting
              list, so we’ll notify you as soon as you can participate.
            </S.Text>

            <Button
              as="a"
              target="_blank"
              rel="noopener noreferrer"
              href="https://savings.club/what-is-savings-club/"
            >
              Learn more
            </Button>
          </SidebarBox>
        </S.Wrapper>
      </Col>
    </General>
  );
};

export default ZipcodeUnavailable;
